import http from './http'

export default {
  getList: params => http.get('/v2/drafts', { params }),
  get: id => http.get(`/v2/drafts/${id}`),
  availableForSetup: () => http.get('/v2/drafts/available-for-setup'),
  availableForNominations: params => http.get('/v2/drafts/available-for-nominations', { params }),
  myNominationsSummary: () => http.get('/v2/drafts/my-nominations-summary'),
  states: () => http.get('/v2/draft-states'),
  setup: data => http.post('/v2/drafts/setup', data),
  forEdit: id => http.get(`/v2/drafts/${id}/edit`),
  update: (id, data) => http.put(`/v2/drafts/${id}`, data, { silent: true }),
  setProgramColor: (id, color) => http.patch(`/v2/drafts/${id}/program-color`, { color }, { silent: true, localSuccess: true }),
  generateProgram: id => http.post(`/v2/drafts/${id}/program`, {}, { silent: true, localSuccess: true }),
  approveProgram: id => http.post(`/v2/drafts/${id}/program/approve`, {}, { silent: true, localSuccess: true }),
  publishNominations: id => http.patch(`/v2/drafts/${id}/nominations-published`, {}, { silent: true }),
  events: id => http.get(`/v2/drafts/${id}/events`),
  updateRules: (id, data) => http.patch(`/v2/drafts/${id}/rules`, data, { silent: true, localSuccess: true }),
  delete: id => http.delete(`/v2/drafts/${id}`, { silent: true }),
  restore: id => http.patch(`/v2/drafts/${id}/restore`, {}, { silent: true })
}



// WEBPACK FOOTER //
// ./src/services/api/drafts.js